<span class="am-flex-align gap-xxs history-box-entry" [class.simplified]="simplified" [ngClass]="entry.classList" (click)="callbackHandler()">
  <span class="am-flex-center icon-tick"></span>
  <span>{{ entry.main }}</span>
  @if (entry.tooltip_text_over) {
    <span class="history-box-entry-with-tooltip">
      <span>{{ entry.tooltip_text_over }}</span>
      <span class="web-tooltip white short left-1000" [class.bottom]="!photoTn" [class.left]="photoTn">
        {{ entry.tooltip }}
      </span>
    </span>
  }
  @if (showToggler) { <span class="am-flex-align font-icon mla icon-arrow-down" [class.rotate]="boxOpen" (click)="toggleBoxHandler($event)"></span> }
</span>
